import styles from './StatusBlock.module.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  isSent: boolean;
}

const StatusBlock = ({ isSent }: Props) => {
  const { t } = useTranslation();

  return (
    <label className={styles.containerBlock}>
      <span className={styles.labelText}>{t('order_dispatch_status')}</span>
      <span className={styles.name}>{isSent ? t('sent') : t('not_sent')}</span>
    </label>
  );
};

export default StatusBlock;
